import {
  Button,
  ButtonLink,
  Stack,
  TextAreaFieldController,
  TextInputFieldController,
} from '@fukuri-admins/ui/common';
import { getGroupsLink } from '~/utils/getLinks';

type Props = {
  isButtonDisabled: boolean;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
};

/**
 * グループ作成フォームのプレゼンテーションコンポーネント
 *
 * @param isButtonDisabled - 送信ボタンの無効化フラグ
 * @param onSubmit - フォーム送信ハンドラ
 */
export const CreateGroupFormPresentation: React.FC<Props> = ({ onSubmit, isButtonDisabled }) => (
  <form onSubmit={onSubmit}>
    <Stack direction='column' gap={24} width='466px'>
      <TextInputFieldController
        name='name'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: 'グループ名',
        }}
        textInput={{
          type: 'text',
          placeholder: '例）グループA',
        }}
      />
      <TextInputFieldController
        name='groupId'
        fieldWrapperProps={{
          labelType: 'required',
          labelText: 'グループID',
          beforeMessage: '英数字のみ使用可能。',
        }}
        textInput={{
          type: 'text',
          placeholder: '例）groupA',
        }}
      />
      <TextAreaFieldController
        name='description'
        fieldWrapperProps={{
          labelText: '説明',
          beforeMessage: '200文字まで。',
        }}
        textArea={{
          placeholder: '例）従業員数500名以上',
        }}
      />
      <Stack direction='row' gap={16}>
        <ButtonLink to={getGroupsLink()} variant='outline' size='md'>
          キャンセル
        </ButtonLink>
        <Button type='submit' size='md' disabled={isButtonDisabled}>
          作成
        </Button>
      </Stack>
    </Stack>
  </form>
);
